import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxsModule } from '@ngxs/store';
import { MetaModule } from '@x/common/meta';
import { OperationModule } from '@x/common/operation';
import { ContentRenderModule } from '@x/content/render';
import { SectionWithImageModule } from '@x/content/render/dynamic-components/section-with-image/section-with-image.module';
import { ChannelGatewayComponent } from '@x/ecommerce-shop/app/channel/channel-gateway.component';
import { ChannelRoutingModule } from '@x/ecommerce-shop/app/channel/channel-routing.module';
import {
  ChannelHomeComponent,
  ChannelPickerComponent,
} from '@x/ecommerce-shop/app/channel/components';
import { ChannelPickerOptonComponent } from '@x/ecommerce-shop/app/channel/components/channel-picker/channel-picker-opton.component';
import { ChannelRouterComponent } from '@x/ecommerce-shop/app/channel/components/channel-router/channel-router.component';
import { ChannelState } from '@x/ecommerce-shop/app/channel/state';
import { AuthModule } from '@x/ecommerce-shop/app/core/auth/auth.module';
import { OrderModule } from '@x/ecommerce-shop/app/core/order/order.module';
import { RegionModule } from '@x/ecommerce-shop/app/core/region/region.module';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { BrandingModule } from '@x/ecommerce-shop/app/core/shop-ui/components/branding/branding.module';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { FlagIconModule } from '@x/ecommerce-shop/app/core/shop-ui/components/flag-icon/flag-icon.module';
import { GhostPageRowModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-page-row/ghost-page-row.module';
import { GhostSectionOneComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-section-one/ghost-section-one.component';
import { GhostSectionWithImageComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-section-with-image/ghost-section-with-image.component';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title';
import { HeaderLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/header-layout/header-layout.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { ShopLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/shop-layout/shop-layout.module';
import { SidebarLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/sidebar-layout/sidebar-layout.module';
import { MenuUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/menu-ui/menu-ui.module';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { NotFoundModule } from '@x/ecommerce-shop/app/core/shop-ui/components/not-found/not-found.module';
import { ShopFooterModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-footer/shop-footer.module';
import { ShopHeaderModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-header/shop-header.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { SearchModule } from 'apps/ecommerce-shop/src/app/core/search';
import { LoaderModule } from 'libs/common/src/loader';
import { ChannelNotFoundComponent } from './components/channel-not-found/channel-not-found.component';

@NgModule({
  declarations: [
    ChannelGatewayComponent,
    ChannelRouterComponent,
    ChannelHomeComponent,
    ChannelPickerComponent,
    ChannelPickerOptonComponent,
    ChannelNotFoundComponent,
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([ChannelState]),
    ChannelRoutingModule,
    LoaderModule,
    PageLayoutModule,
    MatSidenavModule,
    RegionModule,
    AuthModule,
    OrderModule,
    MatButtonModule,
    ShopHeaderModule,
    ShopFooterModule,
    RoutingModule,
    ShopLayoutModule,
    FlagIconModule,
    OperationModule,
    SearchModule,
    ContentRenderModule,
    GhostTitleModule,
    GhostPageRowModule,
    UtilsModule,
    FontAwesomeModule,
    MetaModule,
    HeaderLayoutModule,
    SidebarLayoutModule,
    MatTooltipModule,
    MenuUiModule,
    CloseButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    NeedHelpModule,
    BrandingModule,
    NotFoundModule,
    GhostSectionWithImageComponent,
    GhostSectionOneComponent,
    SectionWithImageModule,
  ],
})
export class ChannelModule {}
